import React from "react";
import AdminStats from "./AdminStats";
import AdminList from "./AdminList";
import DealyGoOffer from "./DealyGoOffer";

const AdminPanel = () => {
    return (
        <div>
            <AdminStats />
            <AdminList />
            <DealyGoOffer />
        </div>
    );
};

export default AdminPanel;
